'use client';

import React, {useState, useEffect} from 'react';
import {CustomAlert, LoginPage, OhidLoginPage} from '@optum-rx-pbm/rx-customsite-utah-components';
import {useSelector} from 'react-redux';
import {useParams, useSearchParams} from 'next/navigation';

import {AEMContentApiType} from '../../../redux/services/types';
import {LT_MSID, LT_OHID, LT_OHID_SESSION, LT_MSID_SESSION, LT_DOMAIN} from '../../../common/constants';

export default function PreLogin() {
  const params = useParams();
  const searchParams = useSearchParams();
  const errorCode = searchParams?.get('error_code') ?? '';
  const [isActive, setIsActive] = useState(errorCode !== '');
  let authType: string = params?.['authType'] && params?.['authType']?.[0] === LT_OHID ? LT_OHID : LT_MSID;
  authType = authType.toLowerCase();
  const {loginPageContent, errorContent} = useSelector((state: AEMContentApiType) => {
    const queries = Object.values(state.aemContentApi.queries);
    return {loginPageContent: queries[0]?.data?.loginPageContent, errorContent: queries[0]?.data?.errorContent};
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsActive(false);
    }, 15000);
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  const LoginComponent = authType === LT_OHID ? OhidLoginPage : LoginPage;

  return (
    <>
      <CustomAlert
        severity="error"
        errorMessage={errorContent?.[errorCode] ?? errorContent?.['00000'] ?? ''}
        isActive={isActive}
        setIsActive={setIsActive}
      />
      <LoginComponent
        loginContent={loginPageContent}
        authType={authType}
        msidAuthType={LT_MSID}
        ohidLoginType={LT_OHID_SESSION}
        msidLoginType={LT_MSID_SESSION}
        domainName={LT_DOMAIN}
      />
    </>
  );
}
